module.exports = __webpack_public_path__ + "img/12f1.8c3ae6f7.jpg";